import { Construction } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { EmptyState } from '@/components/common/empty-state';
import { PageHeader } from '@/components/common/page-header';
import { Button } from '@/components/ui/button';
import { useDocumentTitle } from '@/hooks/use-document-title';
import { NAVIGATION, ROUTE_LABELS } from '@/lib/navigation';

/** Página exibida para módulos de fases ainda não entregues. */
export function ModulePlaceholderPage() {
  const { pathname } = useLocation();
  const item = NAVIGATION.find((n) => pathname === n.to || pathname.startsWith(`${n.to}/`));
  const label = ROUTE_LABELS[pathname] ?? item?.label ?? 'Módulo';
  useDocumentTitle(label);

  return (
    <>
      <PageHeader title={label} />
      <EmptyState
        icon={Construction}
        title={`${label}: previsto para a Fase ${item?.phase ?? '—'}`}
        description="Este módulo ainda não foi implementado. A navegação está disponível para apresentar a estrutura do sistema; nenhuma funcionalidade aqui está simulada."
        className="bg-card py-16"
        action={
          <Button asChild variant="outline">
            <Link to="/dashboard">Voltar ao início</Link>
          </Button>
        }
      />
    </>
  );
}
